/* PERROWALL — modale de capture (pop-up bienvenue + exit-intent).
 * Orchestration SOTA 2026, pensée capture max SANS lassitude :
 *  - jamais trop tôt : délai minimum d'engagement (MIN_DWELL) avant tout affichage ;
 *  - bienvenue déclenchée à l'engagement (scroll OU délai OU Nᵉ page vue) ;
 *  - 2ᵉ CHANCE à l'exit-intent MÊME si la bienvenue a été ignorée (avec un écart mini) ;
 *  - plafond strict par session (bienvenue + exit, jamais plus) ;
 *  - cooldown inter-session ESCALADÉ selon la lassitude (refus répétés -> on espace) ;
 *  - jamais réaffiché une fois inscrit ; suppression tant que le consentement n'est pas décidé.
 * Réutilise window.PWLead (pw-lead-capture.js). Mobile-first, event-based, defer.
 */
(function () {
  'use strict';
  var el = document.getElementById('pw-capture-modal');
  if (!el) { return; }

  /* ---- clés de persistance ---- */
  var K_DONE = 'pw_lead_done';        // localStorage : inscrit -> plus jamais
  var K_LAST = 'pw_modal_last';       // localStorage : ts du dernier affichage
  var K_DISMISS = 'pw_modal_dismiss'; // localStorage : nb de sessions ignorées (cooldown escaladé)
  var K_PV = 'pw_pv';                 // localStorage : compteur pages vues
  var S_COUNT = 'pw_modal_scount';    // sessionStorage : affichages cette session
  var S_DISMISSED = 'pw_modal_sdis';  // sessionStorage : lassitude déjà comptée cette session

  /* ---- réglages (data-attrs section) ---- */
  var cfg = {
    welcome: el.getAttribute('data-welcome') === '1',
    wScroll: parseInt(el.getAttribute('data-welcome-scroll') || '40', 10),
    wDelay: parseInt(el.getAttribute('data-welcome-delay') || '20', 10),
    wPv: parseInt(el.getAttribute('data-welcome-pageviews') || '2', 10),
    exit: el.getAttribute('data-exit') === '1',
    freq: parseInt(el.getAttribute('data-freq-days') || '7', 10),
    consent: el.getAttribute('data-consent') || ''
  };

  /* ---- garde-fous de timing ---- */
  var MIN_DWELL_MS = 6000;            // jamais avant 6 s (pas trop tôt)
  var EXIT_ARM_MS = 3000;            // arme l'exit-intent après 3 s
  var GAP_AFTER_WELCOME_MS = 12000;  // 2e chance exit : >= 12 s après la bienvenue (pas coup sur coup)
  var MOBILE_IDLE_MS = 45000;        // exit mobile : repli sur inactivité longue
  var SESSION_MAX = 2;               // bienvenue + exit, jamais plus
  var loadTs = Date.now();

  /* ---- storage helpers (fail-safe) ---- */
  function ls(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function lset(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
  function ss(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function sset(k,v){ try { sessionStorage.setItem(k,v); } catch(e){} }

  /* pages vues cumulées */
  var pv = (parseInt(ls(K_PV) || '0', 10) || 0) + 1; lset(K_PV, String(pv));

  /* snapshot du dernier affichage AVANT cette session : sinon un affichage de
     la session en cours empoisonnerait le cooldown et tuerait la 2e chance. */
  var prevLast = parseInt(ls(K_LAST) || '0', 10) || 0;

  function done(){ return ls(K_DONE) === '1'; }
  function consentDecided(){ return document.cookie.indexOf('pw_consent=') !== -1; }
  function sessionShows(){ return parseInt(ss(S_COUNT) || '0', 10) || 0; }

  /* cooldown inter-session, escaladé selon la lassitude (refus répétés) */
  function cooldownMs(){
    var d = parseInt(ls(K_DISMISS) || '0', 10) || 0;
    var days = cfg.freq;                         // 1er refus : réglage de base
    if (d >= 3) { days = Math.max(cfg.freq, 30); }
    else if (d === 2) { days = Math.max(cfg.freq, 14); }
    return days * 86400000;
  }
  function cooldownActive(){ return prevLast && (Date.now() - prevLast) < cooldownMs(); }

  /* peut-on afficher CE trigger maintenant ? */
  function canShow(trigger){
    if (opened || done() || !consentDecided()) { return false; }
    if (cooldownActive()) { return false; }
    if (sessionShows() >= SESSION_MAX) { return false; }
    if (ss('pw_modal_' + trigger) === '1') { return false; }    // déjà servi cette session
    if (Date.now() - loadTs < MIN_DWELL_MS) { return false; }   // pas trop tôt
    if (trigger === 'exit') {
      var wTs = parseInt(ss('pw_welcome_ts') || '0', 10) || 0;
      if (wTs && Date.now() - wTs < GAP_AFTER_WELCOME_MS) { return false; }
    }
    return true;
  }

  var opened = false;
  var cleanup = [];
  function teardownTriggers(){ cleanup.forEach(function(fn){ fn(); }); cleanup = []; }
  function on(t,e,f,o){ t.addEventListener(e,f,o); cleanup.push(function(){ t.removeEventListener(e,f,o); }); }

  function open(trigger){
    if (!canShow(trigger)) { return; }
    opened = true;
    sset('pw_modal_' + trigger, '1');
    sset(S_COUNT, String(sessionShows() + 1));
    if (trigger === 'welcome') { sset('pw_welcome_ts', String(Date.now())); }
    lset(K_LAST, String(Date.now()));
    teardownTriggers();
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'pw_popup_view', pw_source: trigger }); } catch(e){}
    el.setAttribute('data-source', trigger);
    el.hidden = false;
    requestAnimationFrame(function(){ el.classList.add('pwcm--open'); });
    var email = el.querySelector('[data-pwcm-email]');
    if (email) { try { email.focus({ preventScroll: true }); } catch(e){} }
    document.addEventListener('keydown', onKey);
  }

  /* lassitude comptée une seule fois par session -> escalade le cooldown */
  function markDismissed(){
    if (ss(S_DISMISSED) !== '1') {
      sset(S_DISMISSED, '1');
      lset(K_DISMISS, String((parseInt(ls(K_DISMISS) || '0', 10) || 0) + 1));
    }
  }

  function close(){
    if (!done()) { markDismissed(); }
    el.classList.remove('pwcm--open');
    document.removeEventListener('keydown', onKey);
    opened = false;
    setTimeout(function(){ if (!opened) { el.hidden = true; } }, 300);
    /* 2e chance : ré-arme l'exit (open() re-vérifiera quota + écart) */
    startExit();
  }
  function onKey(e){ if (e.key === 'Escape') { close(); } }

  function bindClose(root){
    var btns = root.querySelectorAll('[data-pwcm-close]');
    for (var i = 0; i < btns.length; i++) { btns[i].addEventListener('click', close); }
  }
  bindClose(el);

  var form = el.querySelector('[data-pwcm-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = el.querySelector('[data-pwcm-email]');
      var btn = form.querySelector('button[type="submit"]');
      var email = (input && input.value || '').trim();
      if (!email || !window.PWLead) { return; }
      if (btn) { btn.disabled = true; }
      window.PWLead.submit(email, { source: 'modal-' + (el.getAttribute('data-source') || 'welcome'), consentText: cfg.consent })
        .then(function (ok) {
          if (btn) { btn.disabled = false; }
          if (!ok) { return; }
          lset(K_DONE, '1');
          var url = window.PWLead.cfg && window.PWLead.cfg.guide_url;
          var dlg = el.querySelector('.pwcm__dialog');
          if (dlg) {
            dlg.classList.add('pwcm__dialog--done');
            dlg.innerHTML =
              '<button class="pwcm__close" type="button" data-pwcm-close aria-label="Fermer">&times;</button>' +
              '<div class="pwcm__done">' +
                '<span class="pwcm__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
                '<h2 class="pwcm__title">Merci&nbsp;! Ton guide est prêt.</h2>' +
                '<p class="pwcm__sub">On t\'en envoie aussi une copie par e-mail, au cas où.</p>' +
                (url ? '<a class="pwcm__btn" href="' + url + '" target="_blank" rel="noopener">Télécharger le guide (PDF)</a>' : '') +
              '</div>';
            bindClose(dlg);
          }
        });
    });
  }

  /* ---- déclencheur bienvenue (engagement, jamais avant MIN_DWELL) ---- */
  function startWelcome(){
    if (!cfg.welcome) { return; }
    var scheduled = false;
    function fire(){ open('welcome'); }
    function fireAtDwell(){
      if (scheduled) { return; }
      scheduled = true;
      var wait = Math.max(0, MIN_DWELL_MS - (Date.now() - loadTs));
      var t = setTimeout(fire, wait);
      cleanup.push(function(){ clearTimeout(t); });
    }
    /* utilisateur déjà engagé (revient sur une Nᵉ page) -> dès la fin du dwell */
    if (pv >= cfg.wPv) { fireAtDwell(); return; }
    /* plafond "pas trop tard" : délai configurable (mais >= dwell) */
    var td = setTimeout(fire, Math.max(MIN_DWELL_MS, cfg.wDelay * 1000));
    cleanup.push(function(){ clearTimeout(td); });
    /* engagement par le scroll */
    on(window, 'scroll', function(){
      var h = document.documentElement;
      var sp = h.scrollTop / ((h.scrollHeight - h.clientHeight) || 1) * 100;
      if (sp >= cfg.wScroll) { fireAtDwell(); }
    }, { passive: true });
  }

  /* ---- déclencheur exit-intent (capte aussi les rebonds + 2e chance) ---- */
  function startExit(){
    if (!cfg.exit || done() || cooldownActive()) { return; }
    if (sessionShows() >= SESSION_MAX || ss('pw_modal_exit') === '1') { return; }
    var hoverable = window.matchMedia && window.matchMedia('(hover:hover)').matches;
    if (hoverable) {
      /* desktop : souris qui sort par le haut (geste de fermeture d'onglet) */
      var t = setTimeout(function(){
        on(document, 'mouseout', function(e){ if (!e.relatedTarget && e.clientY <= 0) { open('exit'); } });
      }, EXIT_ARM_MS);
      cleanup.push(function(){ clearTimeout(t); });
    } else {
      /* mobile : scroll-up rapide près du haut + repli sur inactivité longue */
      var lastY = window.scrollY, lastT = Date.now();
      on(window, 'scroll', function(){
        var y = window.scrollY, now = Date.now();
        var v = (lastY - y) / ((now - lastT) || 1);
        if (y < 150 && v > 1.2) { open('exit'); }
        lastY = y; lastT = now;
      }, { passive: true });
      var idle = setTimeout(function(){ open('exit'); }, MOBILE_IDLE_MS);
      cleanup.push(function(){ clearTimeout(idle); });
    }
  }

  function init(){
    if (done() || cooldownActive() || sessionShows() >= SESSION_MAX) { return; }
    startWelcome();
    startExit();
  }

  /* ---- bootstrap : ne rien afficher tant que le consentement n'est pas décidé ---- */
  if (consentDecided()) {
    init();
  } else {
    document.addEventListener('visitorConsentCollected', function () { setTimeout(init, 600); }, { once: true });
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (consentDecided()) { clearInterval(poll); init(); }
      if (tries > 20) { clearInterval(poll); }
    }, 1500);
  }
})();
